<template>
    <div class="py-4 container-fluid">
      <div class="row">
        <div class="col-12">
          <div class="card">
            <div class="p-3 pb-0 card-header">
              <div class="d-flex justify-content-between">
                <h6 class="mb-2">Ejecuciones</h6>
              </div>
            </div>
            <div class="table-responsive">
              <div class="row p-2">
                <div class="col-4">
                  <label>General</label>
                  <input v-model="search" type="text" class="form-control" placeholder="Buscar..." />
                </div>
                <div class="col-4">
                  <label>Proceso</label>
                  <select v-model="process" type="text" class="form-control" placeholder="País...">
                    <option value="">Todos</option>
                    <option value="Sin Inicio">Sin Inicio</option>
                    <option value="Iniciada">Iniciada</option>
                    <option value="En Proceso">En Proceso</option>
                    <option value="Parcial">Parcial</option>
                    <option value="Completada">Completada</option>
                    <option value="Finalizada">Finalizada</option>  
                    <!-- <option value="Contratado">Contratado</option>
                    <option value="En Pauta">En Pauta</option>
                    <option value="Pauta Terminada">Pauta Terminada</option> -->
                  </select>
                </div>
                <div class="col-4">
                  <label>País</label>
                  <select v-model="country" type="text" class="form-control" placeholder="País...">
                    <option value="">Todos</option>
                    <option value="Costa Rica">Costa Rica</option>
                    <option value="Nicaragua">Nicaragua</option>
                    <option value="Honduras">Honduras</option>
                    <option value="El Salvador">El Salvador</option>
                    <option value="Guatemala">Guatemala</option>
                  </select>
                </div>
              </div>
              <table class="table align-items-center">
                <thead>
                  <th class="text-center">Numero</th>
                  <th class="text-center">Cliente</th>
                  <th class="text-center">Pais</th>
                  <th class="text-center">Marca</th>
                  <th class="text-center">Estado</th>
                  <th class="text-center">Fecha Fin</th>
                </thead>
                <tbody>
                  <Loading v-if="isLoading" />
                  <tr v-for="(contract, index) in paginatedContracts" :key="index">
                    <td class="w-20">
                      <div class="px-2 py-1 d-flex align-items-center">
                        <div class="ms-4">
                          <h6 class="mb-0 text-sm"><a @click="goToView(contract._id)" >{{ contract.Name }}</a></h6>
                        </div>
                      </div>
                    </td>
                    <td>
                      <div class="text-center">
                        <h6 class="mb-0 text-sm" v-if="contract.Cliente__c !=null">{{ contract.Cliente__c }}</h6>
                      </div>
                    </td>
                    <td>
                      <div class="text-center">
                        <h6 class="mb-0 text-sm" v-if="contract.Pais__c !=null">{{ contract.Pais__c }}</h6>
                      </div>
                    </td>
                    <td>
                      <div class="text-center">
                        <h6 class="mb-0 text-sm" >{{ contract.Marca__c }}</h6>
                      </div>
                    </td>
                    <td class="text-sm align-middle">
                      <div class="text-center col">
                        <h6 class="mb-0 text-sm">{{ contract.EstadoDeCampana__c }}</h6>
                      </div>
                    </td>
                    <td>
                      <div class="text-center">
                        <h6 class="mb-0 text-sm">{{ contract.FechaDeFinalizacion__c }}</h6>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
              <div class="mt-4 p-2">
                <button class="btn btn-dark" @click="goToPage(currentPage - 1)" :disabled="currentPage === 1">Anterior</button>
                <button class="btn btn-dark mx-2" @click="goToPage(currentPage + 1)" :disabled="currentPage === totalPages">Siguiente</button>
              </div>
            </div>
            <div v-if="!hasContracts && !isLoading" class="text-center">
              <!-- <img :src="folder" style="max-width: 20%;" /> -->
              <h4>No se encontraron ejecuciones</h4>
            </div>
          </div>
        </div>
      </div>
    </div>
  </template>
  
  <script>
  import Loading from '../../examples/Loading.vue';
  import folder from "@/assets/img/folder.png";
  
  export default {
    name: "tables",
    components: {
      Loading,
    },
    data() {
      return {
        folder,
        contracts: [],
        isLoading: false,
        hasContracts: false,
        search: "",
        country:"",
        process:"",
        currentPage: 1,
        perPage: 10,
      };
    },
    computed: {
      filteredContracts() {
        return this.contracts.filter((contract) => {
          const matchesSearch = contract.Name.toLowerCase().includes(this.search.toLowerCase())||
          contract.Cliente__c.toLowerCase().includes(this.search.toLowerCase())||
          contract.Marca__c.toLowerCase().includes(this.search.toLowerCase());
          const matchesCountry = this.country ? contract.Pais__c.toLowerCase() === this.country.toLowerCase() : true;
          const matchesProcess = this.process ? contract.EstadoDeCampana__c.toLowerCase() === this.process.toLowerCase() : true;

          return matchesSearch && matchesCountry && matchesProcess;
        });
      },
      paginatedContracts() {
        const start = (this.currentPage - 1) * this.perPage;
        const end = start + this.perPage;
        return this.filteredContracts.slice(start, end);
      },
      totalPages() {
        return Math.ceil(this.filteredContracts.length / this.perPage);
      },
    },
    methods: {
      async fetchContracts() {
        this.isLoading = true;
          //let id=localStorage.getItem('AccountId'); 
          fetch(this.$EndPoint+'ejecuciones/')
          //fetch(this.$EndPoint+'ejecuciones/get_by_owner/'+id)
          .then((response) => response.json())
          .then((result) => {
            console.log(result);
            this.contracts = result;
            /* if (this.contracts.length > 0) {
              this.hasContracts = true;
            } else {
              this.hasContracts = false;
            } */
            this.hasContracts = true;
            this.isLoading = false;
          });
      },
      goToPage(page) {
        console.log('paginacion')
        if (page >= 1 && page <= this.totalPages) {
          this.currentPage = page;
        }
      },

      goToView(id){
        this.$router.push('/campaign/'+id);
      }
    },
    created() {
      if (localStorage.getItem('IsLoggedIn') == 'true') {
        this.fetchContracts();
      } else {
        this.$router.push('/signin');
      }
    },
  };
  </script>